import user from 'js/lib/user';

import { useNaptime } from 'bundles/naptimejs';
import OpenCourseMembershipsV1 from 'bundles/naptimejs/resources/openCourseMemberships.v1';

export type PropsFromUseGetS12nCourseMemberships = {
  s12nCourseMemberships: OpenCourseMembershipsV1[];
  mostRecentS12nCourseMembership: OpenCourseMembershipsV1 | undefined;
};

type PropsFromNaptime = {
  openCourseMemberships?: OpenCourseMembershipsV1[];
};

export const useGetS12nCourseMemberships = ({ courses, skip }: { courses?: Array<{ id: string }>; skip?: boolean }) => {
  const {
    data: { openCourseMemberships },
  } = useNaptime<PropsFromNaptime>(() => {
    if (skip || !user.isAuthenticatedUser() || !courses) {
      return {};
    }
    return {
      openCourseMemberships: OpenCourseMembershipsV1.byUser(user.get().id, {}),
    };
  });

  if (!openCourseMemberships || !courses) {
    return {
      s12nCourseMemberships: [],
      mostRecentS12nCourseMembership: undefined,
    };
  }

  const courseIds = courses.map(({ id }) => id);
  const s12nCourseMemberships = openCourseMemberships.filter(
    ({ courseId, isLearner }) => courseIds.includes(courseId) && isLearner
  );
  const mostRecentS12nCourseMembership = s12nCourseMemberships.sort(
    (courseMembershipA, courseMembershipB) => courseMembershipB.timestamp - courseMembershipA.timestamp
  )[0];

  return { s12nCourseMemberships, mostRecentS12nCourseMembership };
};
